import { createAPIService } from './api.service';

export const CONSENT_ENDPOINT = '/consent/api/v1/admin/consents/configurations';

const service = createAPIService(CONSENT_ENDPOINT);

service.getConsentConfigs = async params =>
  (await service.get('', { params: params })).data;

service.getConsentConfigByUniqueName = async uniqueName =>
  (await service.get(`/${uniqueName}`)).data;

service.createConsentConfig = async consentConfig => {
  const response = await service.post('', consentConfig);
  return response.data;
};

service.updateConsentConfig = async (consentConfigId, consentConfig) => {
  const response = await service.patch(`/${consentConfigId}`, consentConfig);
  return response.data;
};

export default service;
